/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_IMMOCONNECT = new InjectionToken<string>('API_BASE_URL_IMMOCONNECT');

@Injectable()
export class ImmoConnectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_IMMOCONNECT) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://dev-external-api.immo-connect.be";
    }

    /**
     * Register a user on the Immo-Connect platform.
     * @return The new user's account details.
     */
    authentication_Register(request: AuthRegisterRequest): Observable<AuthRegisterResponse> {
        let url_ = this.baseUrl + "/v1/Authentication/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_Register(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_Register(<any>response_);
                } catch (e) {
                    return <Observable<AuthRegisterResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthRegisterResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_Register(response: HttpResponseBase): Observable<AuthRegisterResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthRegisterResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result409: any = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
                return throwException("Returned when there was a conflict (existing username/email), refer to the response content for the exact cause.", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthRegisterResponse>(<any>null);
    }

    /**
     * Activate a newly registered user, to complete the registration flow.
     */
    authentication_Activate(request: AuthActivateRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Authentication/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_Activate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_Activate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_Activate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result204: any = null;
                let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
                return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
                return throwException("Returned when the required entry was not found, refer to the response content for the exact cause.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Activate a newly registered user, to complete the registration flow.
     */
    authentication_ResendActivationCode(request: AuthResendActivateRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Authentication/ResendActivationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_ResendActivationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_ResendActivationCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_ResendActivationCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result204: any = null;
                let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
                return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
                return throwException("Returned when the required entry was not found, refer to the response content for the exact cause.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Sign in a user on a supported Immo-Connect application.
     * @return An Immo-Connect session token, which can be used to authenticate the user for a limited timespan.
     */
    authentication_SignIn(request: AuthSignInRequest): Observable<AuthSignInResponse> {
        let url_ = this.baseUrl + "/v1/Authentication/SignIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_SignIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_SignIn(<any>response_);
                } catch (e) {
                    return <Observable<AuthSignInResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthSignInResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_SignIn(response: HttpResponseBase): Observable<AuthSignInResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthSignInResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
                return throwException("Returned when the SignIn failed, refer to the response content for the exact cause.", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthSignInResponse>(<any>null);
    }

    /**
     * Extend the session 'time to live' period.
    Note: the maximum session 'time to live' is set at MaxSessionTimeoutInMinutes,
    if the extension period provided results in a period longer than that it will
    be capped and the session will be extended only to the maximum period allowed (MaxSessionTimeoutInMinutes minutes).
     */
    authentication_ExtendSessionPeriod(request: ExtendSessionRequest): Observable<ExtendSessionResponse> {
        let url_ = this.baseUrl + "/v1/Authentication/ExtendSessionTimeout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_ExtendSessionPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_ExtendSessionPeriod(<any>response_);
                } catch (e) {
                    return <Observable<ExtendSessionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExtendSessionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_ExtendSessionPeriod(response: HttpResponseBase): Observable<ExtendSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExtendSessionResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
                return throwException("Returned when the session was invalid or empty, refer to the response content for the exact cause.", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExtendSessionResponse>(<any>null);
    }

    /**
     * Sign out a user, this will end the active session (provided in the x-ImmoConnect-SessionId header).
     */
    authentication_SignOut(): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Authentication/SignOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_SignOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_SignOut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_SignOut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
                return throwException("Returned when the SignOut failed, refer to the response content for the exact cause.", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Initiate a password reset procedure, if successful an email will be sent with a password reset confirmation code,
    which can be used to reset the password through the CompletePasswordReset call.
     */
    authentication_InitiatePasswordReset(request: InitiatePasswordResetRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Authentication/InitiatePasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_InitiatePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_InitiatePasswordReset(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_InitiatePasswordReset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result204: any = null;
                let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
                return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
                return throwException("Returned when the required entry was not found, refer to the response content for the exact cause.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Validates the password reset Login/ConfirmationCode combination.
    Can be used for validation before sending a CompletePasswordResetRequest) request.
     */
    authentication_ValidatePasswordResetConfirmationCode(request: ValidatePasswordResetConfirmationCodeRequest): Observable<ValidatePasswordResetConfirmationCodeResponse> {
        let url_ = this.baseUrl + "/v1/Authentication/ValidatePasswordResetConfirmationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_ValidatePasswordResetConfirmationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_ValidatePasswordResetConfirmationCode(<any>response_);
                } catch (e) {
                    return <Observable<ValidatePasswordResetConfirmationCodeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidatePasswordResetConfirmationCodeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_ValidatePasswordResetConfirmationCode(response: HttpResponseBase): Observable<ValidatePasswordResetConfirmationCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidatePasswordResetConfirmationCodeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidatePasswordResetConfirmationCodeResponse>(<any>null);
    }

    /**
     * Complete the password reset procedure, if successful the password will be changed and can be used to sign in.
     */
    authentication_CompletePasswordReset(request: CompletePasswordResetRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Authentication/CompletePasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_CompletePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_CompletePasswordReset(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_CompletePasswordReset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result204: any = null;
                let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
                return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Returned when there are request validation errors, refer to the response content for the exact cause.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
                return throwException("Returned when the required entry was not found, refer to the response content for the exact cause.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Checks if the current combination of headers is authenticated for the target application
     */
    authentication_IsAuthenticated(request: IsAuthenticatedRequest): Observable<IsAuthenticatedResponse> {
        let url_ = this.baseUrl + "/v1/Authentication/IsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthentication_IsAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthentication_IsAuthenticated(<any>response_);
                } catch (e) {
                    return <Observable<IsAuthenticatedResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsAuthenticatedResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAuthentication_IsAuthenticated(response: HttpResponseBase): Observable<IsAuthenticatedResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IsAuthenticatedResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = resultData422 !== undefined ? resultData422 : <any>null;
                return throwException("Returned when the request processing failed, refer to the response content for the exact cause.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsAuthenticatedResponse>(<any>null);
    }

    /**
     * Gets the context for the current user
     */
    userContext_GetContext(): Observable<UserContext> {
        let url_ = this.baseUrl + "/v1/UserContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUserContext_GetContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserContext_GetContext(<any>response_);
                } catch (e) {
                    return <Observable<UserContext>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContext>><any>_observableThrow(response_);
        }));
    }

    protected processUserContext_GetContext(response: HttpResponseBase): Observable<UserContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserContext.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContext>(<any>null);
    }

    /**
     * Changes the user preferred language for the current user.
     * @param language (optional) 
     */
    userContext_SetLanguage(language?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/v1/UserContext/SetLanguage?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUserContext_SetLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserContext_SetLanguage(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUserContext_SetLanguage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Gets the context for the current user
     */
    wallet_GetBalance(): Observable<WalletCurrency[]> {
        let url_ = this.baseUrl + "/v1/Wallet/GetBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processWallet_GetBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWallet_GetBalance(<any>response_);
                } catch (e) {
                    return <Observable<WalletCurrency[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WalletCurrency[]>><any>_observableThrow(response_);
        }));
    }

    protected processWallet_GetBalance(response: HttpResponseBase): Observable<WalletCurrency[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(WalletCurrency.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WalletCurrency[]>(<any>null);
    }
}

export class AuthRegisterResponse implements IAuthRegisterResponse {
    personId!: string;
    email!: string;
    userName!: string;

    constructor(data?: IAuthRegisterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.email = _data["email"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AuthRegisterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRegisterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["email"] = this.email;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAuthRegisterResponse {
    personId: string;
    email: string;
    userName: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export class ValidationProblemDetails extends ProblemDetails implements IValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
}

export enum AuthRegisterErrorCode {
    Unknown = 0,
    UserNameIsTaken = 1,
    EmailIsTaken = 2,
}

export class AuthRegisterRequest implements IAuthRegisterRequest {
    email!: string;
    password!: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    applicationId?: string | undefined;
    language?: string | undefined;

    constructor(data?: IAuthRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.applicationId = _data["applicationId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): AuthRegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["applicationId"] = this.applicationId;
        data["language"] = this.language;
        return data;
    }
}

export interface IAuthRegisterRequest {
    email: string;
    password: string;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    applicationId?: string | undefined;
    language?: string | undefined;
}

export enum AuthActivateErrorCode {
    Unknown = 0,
    UserNotFound = 1,
    UserAlreadyActivated = 2,
    InvalidActivationCode = 3,
}

export class AuthActivateRequest implements IAuthActivateRequest {
    login!: string;
    activationCode!: string;

    constructor(data?: IAuthActivateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.activationCode = _data["activationCode"];
        }
    }

    static fromJS(data: any): AuthActivateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthActivateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["activationCode"] = this.activationCode;
        return data;
    }
}

export interface IAuthActivateRequest {
    login: string;
    activationCode: string;
}

export class AuthResendActivateRequest implements IAuthResendActivateRequest {
    login!: string;
    applicationId?: string | undefined;

    constructor(data?: IAuthResendActivateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): AuthResendActivateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResendActivateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IAuthResendActivateRequest {
    login: string;
    applicationId?: string | undefined;
}

export class AuthSignInResponse implements IAuthSignInResponse {
    session!: string;

    constructor(data?: IAuthSignInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.session = _data["session"];
        }
    }

    static fromJS(data: any): AuthSignInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSignInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["session"] = this.session;
        return data;
    }
}

export interface IAuthSignInResponse {
    session: string;
}

export enum AuthSignInErrorCode {
    Unknown = 0,
    InvalidLoginPasswordCombination = 1,
    UnactivatedUser = 2,
    DeactivatedUser = 3,
    SignInThrottled = 4,
}

export class AuthSignInRequest implements IAuthSignInRequest {
    login!: string;
    password!: string;
    applicationId!: string;
    timeoutInMinutes?: number;

    constructor(data?: IAuthSignInRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.password = _data["password"];
            this.applicationId = _data["applicationId"];
            this.timeoutInMinutes = _data["timeoutInMinutes"];
        }
    }

    static fromJS(data: any): AuthSignInRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSignInRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["password"] = this.password;
        data["applicationId"] = this.applicationId;
        data["timeoutInMinutes"] = this.timeoutInMinutes;
        return data;
    }
}

export interface IAuthSignInRequest {
    login: string;
    password: string;
    applicationId: string;
    timeoutInMinutes?: number;
}

export class ExtendSessionResponse implements IExtendSessionResponse {
    sessionExpiryTime?: Date;

    constructor(data?: IExtendSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionExpiryTime = _data["sessionExpiryTime"] ? new Date(_data["sessionExpiryTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtendSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionExpiryTime"] = this.sessionExpiryTime ? this.sessionExpiryTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExtendSessionResponse {
    sessionExpiryTime?: Date;
}

export enum ExtendSessionErrorCode {
    Unknown = 0,
    InvalidOrEmptySession = 1,
}

export class ExtendSessionRequest implements IExtendSessionRequest {
    timeoutInMinutes?: number;

    constructor(data?: IExtendSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeoutInMinutes = _data["timeoutInMinutes"];
        }
    }

    static fromJS(data: any): ExtendSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeoutInMinutes"] = this.timeoutInMinutes;
        return data;
    }
}

export interface IExtendSessionRequest {
    timeoutInMinutes?: number;
}

export enum AuthSignOutErrorCode {
    Unknown = 0,
    InvalidOrEmptySession = 1,
}

export enum InitiatePasswordResetErrorCode {
    Unknown = 0,
    UserNotFound = 1,
    UserBlocked = 2,
}

export class InitiatePasswordResetRequest implements IInitiatePasswordResetRequest {
    login!: string;
    confirmationReturnUrl!: string;
    applicationId?: string | undefined;

    constructor(data?: IInitiatePasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.confirmationReturnUrl = _data["confirmationReturnUrl"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): InitiatePasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InitiatePasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["confirmationReturnUrl"] = this.confirmationReturnUrl;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IInitiatePasswordResetRequest {
    login: string;
    confirmationReturnUrl: string;
    applicationId?: string | undefined;
}

export class ValidatePasswordResetConfirmationCodeResponse implements IValidatePasswordResetConfirmationCodeResponse {
    isValid?: boolean;

    constructor(data?: IValidatePasswordResetConfirmationCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ValidatePasswordResetConfirmationCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePasswordResetConfirmationCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IValidatePasswordResetConfirmationCodeResponse {
    isValid?: boolean;
}

export enum ValidatePasswordResetConfirmationCodeErrorCode {
    Unknown = 0,
}

export class ValidatePasswordResetConfirmationCodeRequest implements IValidatePasswordResetConfirmationCodeRequest {
    login!: string;
    confirmationCode!: string;

    constructor(data?: IValidatePasswordResetConfirmationCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.confirmationCode = _data["confirmationCode"];
        }
    }

    static fromJS(data: any): ValidatePasswordResetConfirmationCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePasswordResetConfirmationCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export interface IValidatePasswordResetConfirmationCodeRequest {
    login: string;
    confirmationCode: string;
}

export enum CompletePasswordResetErrorCode {
    Unknown = 0,
    UserNotFound = 1,
    InvalidConfirmationCode = 2,
}

export class CompletePasswordResetRequest implements ICompletePasswordResetRequest {
    login!: string;
    confirmationCode!: string;
    newPassword!: string;
    applicationId?: string | undefined;

    constructor(data?: ICompletePasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.confirmationCode = _data["confirmationCode"];
            this.newPassword = _data["newPassword"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): CompletePasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["confirmationCode"] = this.confirmationCode;
        data["newPassword"] = this.newPassword;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface ICompletePasswordResetRequest {
    login: string;
    confirmationCode: string;
    newPassword: string;
    applicationId?: string | undefined;
}

export class IsAuthenticatedResponse implements IIsAuthenticatedResponse {
    errorCode?: AuthenticationErrorCode;
    isAuthenticated?: boolean;

    constructor(data?: IIsAuthenticatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.isAuthenticated = _data["isAuthenticated"];
        }
    }

    static fromJS(data: any): IsAuthenticatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsAuthenticatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["isAuthenticated"] = this.isAuthenticated;
        return data;
    }
}

export interface IIsAuthenticatedResponse {
    errorCode?: AuthenticationErrorCode;
    isAuthenticated?: boolean;
}

export enum AuthenticationErrorCode {
    None = 0,
    InvalidPartnerApiKey = 1,
    InvalidSession = 2,
    InvalidCustomerApiKey = 3,
    CustomerApiKeyNotAuthorizedForPartnerApplication = 4,
    PartnerApiKeyNotAuthorizedForTargetApplication = 5,
    PartnerApiKeyNotAuthorizedForTargetApplicationTemplate = 6,
    UserNotAuthorizedForTargetApplication = 7,
    UserNotAuthorizedForTargetApplicationTemplate = 8,
    PartnerApiKeyNotAuthorizedForUserApplication = 9,
    PartnerApiKeyNotAuthorizedForUserApplicationTemplate = 10,
    Unknown = -1,
}

export class IsAuthenticatedRequest implements IIsAuthenticatedRequest {
    applicationID?: string;

    constructor(data?: IIsAuthenticatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationID = _data["applicationID"];
        }
    }

    static fromJS(data: any): IsAuthenticatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsAuthenticatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationID"] = this.applicationID;
        return data;
    }
}

export interface IIsAuthenticatedRequest {
    applicationID?: string;
}

export class UserContext implements IUserContext {
    organizationId?: string | undefined;
    organizationInvoiceAddress?: UserContextAddress | undefined;
    organizationName?: string | undefined;
    organizationOfficialName?: string | undefined;
    organizationCommercialName?: string | undefined;
    organizationNumber?: string | undefined;
    organizationLogoUrl?: string | undefined;
    personId?: string | undefined;
    personName?: string | undefined;
    personFirstName?: string | undefined;
    personLastName?: string | undefined;
    personProfilePictureUrl?: string | undefined;
    userPreferredLanguage?: string | undefined;
    signedInApplicationRoleCode?: string | undefined;

    constructor(data?: IUserContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationInvoiceAddress = _data["organizationInvoiceAddress"] ? UserContextAddress.fromJS(_data["organizationInvoiceAddress"]) : <any>undefined;
            this.organizationName = _data["organizationName"];
            this.organizationOfficialName = _data["organizationOfficialName"];
            this.organizationCommercialName = _data["organizationCommercialName"];
            this.organizationNumber = _data["organizationNumber"];
            this.organizationLogoUrl = _data["organizationLogoUrl"];
            this.personId = _data["personId"];
            this.personName = _data["personName"];
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.personProfilePictureUrl = _data["personProfilePictureUrl"];
            this.userPreferredLanguage = _data["userPreferredLanguage"];
            this.signedInApplicationRoleCode = _data["signedInApplicationRoleCode"];
        }
    }

    static fromJS(data: any): UserContext {
        data = typeof data === 'object' ? data : {};
        let result = new UserContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationInvoiceAddress"] = this.organizationInvoiceAddress ? this.organizationInvoiceAddress.toJSON() : <any>undefined;
        data["organizationName"] = this.organizationName;
        data["organizationOfficialName"] = this.organizationOfficialName;
        data["organizationCommercialName"] = this.organizationCommercialName;
        data["organizationNumber"] = this.organizationNumber;
        data["organizationLogoUrl"] = this.organizationLogoUrl;
        data["personId"] = this.personId;
        data["personName"] = this.personName;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["personProfilePictureUrl"] = this.personProfilePictureUrl;
        data["userPreferredLanguage"] = this.userPreferredLanguage;
        data["signedInApplicationRoleCode"] = this.signedInApplicationRoleCode;
        return data;
    }
}

export interface IUserContext {
    organizationId?: string | undefined;
    organizationInvoiceAddress?: UserContextAddress | undefined;
    organizationName?: string | undefined;
    organizationOfficialName?: string | undefined;
    organizationCommercialName?: string | undefined;
    organizationNumber?: string | undefined;
    organizationLogoUrl?: string | undefined;
    personId?: string | undefined;
    personName?: string | undefined;
    personFirstName?: string | undefined;
    personLastName?: string | undefined;
    personProfilePictureUrl?: string | undefined;
    userPreferredLanguage?: string | undefined;
    signedInApplicationRoleCode?: string | undefined;
}

export class UserContextAddress implements IUserContextAddress {
    addressTypeCode?: string | undefined;
    countryISOCode?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    streetBox?: string | undefined;
    geometry?: string | undefined;
    longitude?: string | undefined;
    latitude?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IUserContextAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressTypeCode = _data["addressTypeCode"];
            this.countryISOCode = _data["countryISOCode"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.streetBox = _data["streetBox"];
            this.geometry = _data["geometry"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UserContextAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressTypeCode"] = this.addressTypeCode;
        data["countryISOCode"] = this.countryISOCode;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["streetBox"] = this.streetBox;
        data["geometry"] = this.geometry;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUserContextAddress {
    addressTypeCode?: string | undefined;
    countryISOCode?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    streetBox?: string | undefined;
    geometry?: string | undefined;
    longitude?: string | undefined;
    latitude?: string | undefined;
    comment?: string | undefined;
}

export class WalletCurrency implements IWalletCurrency {
    currencyTypeCode!: string | undefined;
    amount!: number;
    unit!: string | undefined;

    constructor(data?: IWalletCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyTypeCode = _data["currencyTypeCode"];
            this.amount = _data["amount"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): WalletCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyTypeCode"] = this.currencyTypeCode;
        data["amount"] = this.amount;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IWalletCurrency {
    currencyTypeCode: string | undefined;
    amount: number;
    unit: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}